export function createSortQuery(orderBy, orderDir) {
	return `&orderBy=${orderBy}&orderDirection=${orderDir}`;
}

export function createPaginationQuery(pagination) {
	return `&pageSize=${pagination.size}&pageNumber=${pagination.page}`;
}



// WEBPACK FOOTER //
// ./src/api/helpers/query.js